// Library Methods
import i18next from "i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

import contrastSensitivity1Img from "src/assets/images/operating-manual/appendix-e/cs-1.png";
import contrastSensitivity1FrImg from "src/assets/images/operating-manual/appendix-e/cs-1-fr.png";
import contrastSensitivity2Img from "src/assets/images/operating-manual/appendix-e/cs-2.png";
import contrastSensitivity2FrImg from "src/assets/images/operating-manual/appendix-e/cs-2-fr.png";
import contrastSensitivity3Img from "src/assets/images/operating-manual/appendix-e/cs-3.png";
import contrastSensitivity3FrImg from "src/assets/images/operating-manual/appendix-e/cs-3-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

type AppendixEType = {
  title: string;
};

const AppendixE = ({ title }: AppendixEType) => {
  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <OperatingManualContent title={title}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <img
          src={
            currentLang === "fr"
              ? contrastSensitivity1FrImg
              : contrastSensitivity1Img
          }
          width="100%"
          alt="cs-1"
        />
        <img
          src={
            currentLang === "fr"
              ? contrastSensitivity2FrImg
              : contrastSensitivity2Img
          }
          width="100%"
          alt="cs-2"
        />
        <img
          src={
            currentLang === "fr"
              ? contrastSensitivity3FrImg
              : contrastSensitivity3Img
          }
          width="100%"
          alt="cs-3"
        />
      </Box>
    </OperatingManualContent>
  );
};

export default AppendixE;
